<template>
  <svg
    :height="height"
    :width="width"
    version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
       viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
    <path style="fill:#E09B2D;" d="M339.689,137.952c0,18.301-9.127,34.881-23.916,46.977H196.227
      c-9.104-7.452-16.071-16.591-20.057-26.805c-2.507-6.366-3.859-13.137-3.859-20.173c0-11.08,3.351-21.536,9.278-30.744
      c16.603-25.799,24.76-56.128,24.76-86.803V0h99.316v20.404c0,30.675,8.157,61.004,24.76,86.803
      C336.339,116.415,339.689,126.871,339.689,137.952z"/>
    <path style="fill:#CE8925;" d="M275,135.225c-0.058-0.046-0.116-0.104-0.162-0.162c-8.353-8.284-19.768-12.755-31.542-12.755
      h-21.132c-11.877,0-23.373,4.564-31.761,12.975c-6.343,6.366-11.265,14.153-14.234,22.842c3.986,10.213,10.953,19.352,20.057,26.805
      h96.289V177.5C292.516,160.978,285.814,146.051,275,135.225z"/>
    <path style="fill:#F7B239;" d="M298.267,135.231c-0.054-0.054-0.11-0.11-0.165-0.164c-8.353-8.29-19.764-12.761-31.532-12.761
      h-21.133c-11.877,0-23.373,4.568-31.76,12.979c-10.782,10.812-17.448,25.736-17.448,42.216v102.026
      c0,32.786,25.992,60.211,58.775,60.744c33.479,0.544,60.776-26.431,60.776-59.773V177.501
      C315.778,160.983,309.082,146.046,298.267,135.231z M275.312,280.499c0,10.648-8.663,19.311-19.312,19.311
      c-10.649,0-19.312-8.663-19.312-19.311v-39.253c0-10.648,8.663-19.311,19.312-19.311c10.649,0,19.312,8.663,19.312,19.311V280.499z"
      />
    <path style="fill:#E09B2D;" d="M255.999,322.37l-0.706-0.006c-22.695-0.369-41.158-19.586-41.158-42.838V177.5
      c0-11.166,4.341-21.667,12.222-29.572c4.891-4.905,11.845-7.716,19.08-7.716h21.133c7.178,0,14.074,2.758,18.918,7.565l0.117,0.116
      c7.911,7.911,12.267,18.426,12.267,29.606v102.997c0,11.186-4.356,21.701-12.262,29.61
      C277.699,318.015,267.185,322.37,255.999,322.37z M255.507,307.347l0.549,0.003c7.118,0,13.861-2.793,18.932-7.865
      c5.072-5.071,7.865-11.816,7.865-18.99V177.499c0-7.17-2.795-13.913-7.869-18.986l-0.095-0.095
      c-2.033-2.017-5.072-3.187-8.318-3.187h-21.134c-3.273,0-6.351,1.204-8.445,3.302c-5.054,5.069-7.837,11.803-7.837,18.965v102.026
      C229.155,294.62,240.972,307.093,255.507,307.347z"/>
    <g>
      <path style="fill:#B3B3B3;" d="M257.842,373.708h-38.626c-6.38,0-11.554-5.173-11.554-11.554s5.174-11.554,11.554-11.554h38.626
        c6.38,0,11.554,5.173,11.554,11.554S264.223,373.708,257.842,373.708z"/>
      <path style="fill:#B3B3B3;" d="M292.789,401.366h-38.626c-6.38,0-11.554-5.173-11.554-11.554c0-6.381,5.174-11.554,11.554-11.554
        h38.626c6.38,0,11.554,5.173,11.554,11.554C304.343,396.194,299.171,401.366,292.789,401.366z"/>
      <path style="fill:#B3B3B3;" d="M257.842,429.025h-38.626c-6.38,0-11.554-5.173-11.554-11.554s5.174-11.554,11.554-11.554h38.626
        c6.38,0,11.554,5.173,11.554,11.554S264.223,429.025,257.842,429.025z"/>
      <path style="fill:#B3B3B3;" d="M292.789,456.683h-38.626c-6.38,0-11.554-5.173-11.554-11.554s5.174-11.554,11.554-11.554h38.626
        c6.38,0,11.554,5.173,11.554,11.554S299.171,456.683,292.789,456.683z"/>
      <path style="fill:#B3B3B3;" d="M257.842,484.342h-38.626c-6.38,0-11.554-5.173-11.554-11.554c0-6.381,5.174-11.554,11.554-11.554
        h38.626c6.38,0,11.554,5.173,11.554,11.554C269.395,479.169,264.223,484.342,257.842,484.342z"/>
      <path style="fill:#B3B3B3;" d="M292.789,512h-38.626c-6.38,0-11.554-5.173-11.554-11.554s5.174-11.554,11.554-11.554h38.626
        c6.38,0,11.554,5.173,11.554,11.554S299.171,512,292.789,512z"/>
    </g>
    <path style="fill:#B27214;" d="M229.566,134.507V81.639c0-14.599,11.836-26.435,26.435-26.435l0,0
      c14.599,0,26.435,11.836,26.435,26.435v52.869c0,14.599-11.836,26.435-26.435,26.435l0,0
      C241.401,160.942,229.566,149.107,229.566,134.507z"/>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    width: {
      type: [Number, String],
      default: 18
    },
    height: {
      type: [Number, String],
      default: 18
    },
    iconColor: {
      type: String,
      default: 'currentColor'
    }
  }
}
</script>
